import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { MonthlyHoursVM, SiteCodes } from '../entities/global/model';
import { SafetyConfigService } from '../services/safety-config.service';

@Component({
  selector: 'app-config-view-edit-mon-hrs',
  templateUrl: './config-view-edit-mon-hrs.component.html',
  styleUrls: ['./config-view-edit-mon-hrs.component.css']
})
export class ConfigViewEditMonHrsComponent implements OnInit {

  constructor(
    private _safetyConfigService:SafetyConfigService,
    private _notify: NotificationsService,
  ) { }
  Janauary:number=1
  February:number=2
  March:number=3
  April:number=4
  May:number=5
  June:number=6
  July:number=7
  August:number=8
  September:number=9
  October:number=10
  November:number=11
  December:number=12
  HoursForMonth:number=0
  HoursforJanuary: number
  HoursforFebruary:number
  HoursforMarch:number
  HoursforApril:number
  HoursforMay:number
  HoursforJune:number
  HoursforJuly:number
  HoursforAugust:number
  HoursforSeptember:number
  HoursforOctober:number
  HoursforNovember:number
  HoursforDecember:number
  selectedyear:number

  inputValuestate:number
  siteCodesList: SiteCodes[]=[];


  AllMonthHours:MonthlyHoursVM[]
  //current year
  mydate =new Date();
  ngOnInit() {
    this. loadSiteList();
    this.selectedyear=this.mydate.getFullYear(); 
    
  }


  state = new FormControl("", [Validators.required]);
  getErrorMessage() {
    return this.state.hasError("required") ? "You must enter a value" : "";
  }

  loadSiteList(){
   this._safetyConfigService.getAllSitesList().subscribe(sites =>
   { 
     console.log('sitelist',sites)
     this.siteCodesList=sites;
     
   });
 }

 loadMonthlyHours(){
 // this.selectedyear=value;
 if (!this.selectedyear) {
   return;
 }
 let model= new MonthlyHoursVM();
 model.Year=this.selectedyear;
 model.inputValuestate=this.inputValuestate
 this._safetyConfigService.GetAllMonthlyHOurs(model).subscribe((res: any) =>
   {
     this.AllMonthHours = res;

     if(this.AllMonthHours.length>0)
     {
       this.AllMonthHours.map(x=>{
         if(x.Month==1){
           this.HoursforJanuary = x.HoursForMonth;
         }
         if(x.Month==2){
          this.HoursforFebruary = x.HoursForMonth;
        }
        if(x.Month==3){
          this.HoursforMarch = x.HoursForMonth;
        }
        if(x.Month==4){
          this.HoursforApril = x.HoursForMonth;
        }
        if(x.Month==5){
          this.HoursforMay = x.HoursForMonth;
        }
        if(x.Month==6){
          this.HoursforJune = x.HoursForMonth;
        }
        if(x.Month==7){
          this.HoursforJuly = x.HoursForMonth;
        }
        if(x.Month==8){
          this.HoursforAugust = x.HoursForMonth;
        }
        if(x.Month==9){
          this.HoursforSeptember = x.HoursForMonth;
        }
        if(x.Month==10){
          this.HoursforOctober = x.HoursForMonth;
        }
        if(x.Month==11){
          this.HoursforNovember = x.HoursForMonth;
        }
        if(x.Month==12){
          this.HoursforDecember = x.HoursForMonth;
        }
       })
     }
  
     console.log("monthly hours", res.HoursForMonth)
   });
   this.resetFeilds();
}

resetFeilds()
{
  this.HoursforJanuary=0;
  this.HoursforFebruary=0;
  this.HoursforMarch=0;
  this.HoursforApril=0;
  this.HoursforMay=0;
  this.HoursforJune=0;
  this.HoursforJuly=0;
  this.HoursforAugust=0;
  this.HoursforSeptember=0;
  this.HoursforOctober=0;
  this.HoursforNovember=0;
  this.HoursforDecember=0;

}

  UpdateJanuary()
  {
    let model= new MonthlyHoursVM();
    model.HoursForMonth=this.HoursforJanuary
    model.Year= this.selectedyear
    model.Month=this.Janauary
    model.inputValuestate=this.inputValuestate

   this._safetyConfigService.addMonthlyHours(model).subscribe((r: any)=>
    {
      //console.log("result", r)
        // if(r=true){
        //   this.toastr.success('Saved');
        //   }
        //   else{
        //     this.toastr.error('Error');
        //   }
          if(r){
          
          this._notify.success('Saved Sucessfully');

          return
        }
    })
  }

  
   
  
  UpdateFebruary()
  {
    let model= new MonthlyHoursVM();
    model.HoursForMonth=this.HoursforFebruary
    model.Year= this.selectedyear
    model.Month=this.February
    model.inputValuestate=this.inputValuestate

   this._safetyConfigService.addMonthlyHours(model).subscribe((r: any)=>
    {
      if(r){
          this._notify.success('Saved Sucessfully');
        
          return
        }
        
    })
  }

  UpdateMarch()
  {
    let model= new MonthlyHoursVM();
    model.HoursForMonth=this.HoursforMarch
    model.Year= this.selectedyear
    model.Month=this.March
    model.inputValuestate=this.inputValuestate

   this._safetyConfigService.addMonthlyHours(model).subscribe((r: any)=>
    {
       if(r){
          this._notify.success('Saved Sucessfully');
          return
        }
    })
  }
  UpdateApril()
  {
    let model= new MonthlyHoursVM();
    model.HoursForMonth=this.HoursforApril
    model.Year= this.selectedyear
    model.Month=this.April
    model.inputValuestate=this.inputValuestate


   this._safetyConfigService.addMonthlyHours(model).subscribe((r: any)=>
    {
      if(r){
          this._notify.success('Saved Sucessfully');
          return
        }
    })
  }

  UpdateMay()
  {
    let model= new MonthlyHoursVM();
    model.HoursForMonth=this.HoursforMay
    model.Year= this.selectedyear
    model.Month=this.May
    model.inputValuestate=this.inputValuestate


   this._safetyConfigService.addMonthlyHours(model).subscribe((r: any)=>
    {
      if(r){
          this._notify.success('Saved Sucessfully');
          return
        }
    })
  }

  UpdateJune()
  {
    let model= new MonthlyHoursVM();
    model.HoursForMonth=this.HoursforJune
    model.Year= this.selectedyear
    model.Month=this.June
    model.inputValuestate=this.inputValuestate
this._safetyConfigService.addMonthlyHours(model).subscribe((r: any)=>
    {
       if(r){
          this._notify.success('Saved Sucessfully');
          return
        }
    })
  }

  UpdateJuly()
  {
    let model= new MonthlyHoursVM();
    model.HoursForMonth=this.HoursforJuly
    model.Year= this.selectedyear
    model.Month=this.July
    model.inputValuestate=this.inputValuestate
this._safetyConfigService.addMonthlyHours(model).subscribe((r: any)=>
    {
       if(r){
          this._notify.success('Saved Sucessfully');
          return
        }
    })
  }

  UpdateAugust()
  {
    let model= new MonthlyHoursVM();
    model.HoursForMonth=this.HoursforAugust
    model.Year= this.selectedyear
    model.Month=this.August
    model.inputValuestate=this.inputValuestate


   this._safetyConfigService.addMonthlyHours(model).subscribe((r: any)=>
    {
      if(r){
          this._notify.success('Saved Sucessfully');
          return
        }
    })
  }

  UpdateSep()
  {
    let model= new MonthlyHoursVM();
    model.HoursForMonth=this.HoursforSeptember
    model.Year= this.selectedyear
    model.Month=this.September
    model.inputValuestate=this.inputValuestate


   this._safetyConfigService.addMonthlyHours(model).subscribe((r: any)=>
    {
      if(r){
          this._notify.success('Saved Sucessfully');
          return
        }
    })
  }

  UpdateOct()
  {
    let model= new MonthlyHoursVM();
    model.HoursForMonth=this.HoursforOctober
    model.Year= this.selectedyear
    model.Month=this.October
    model.inputValuestate=this.inputValuestate


   this._safetyConfigService.addMonthlyHours(model).subscribe((r: any)=>
    {
      if(r){
          this._notify.success('Saved Sucessfully');
          return
        }
    })
  }

  UpdateNov()
  {
    let model= new MonthlyHoursVM();
    model.HoursForMonth=this.HoursforNovember
    model.Year= this.selectedyear
    model.Month=this.November
    model.inputValuestate=this.inputValuestate


   this._safetyConfigService.addMonthlyHours(model).subscribe((r: any)=>
    {
      if(r){
          this._notify.success('Saved Sucessfully');
          return
        }
    })
  }

  UpdateDec()
  {
    let model= new MonthlyHoursVM();
    model.HoursForMonth=this.HoursforDecember
    model.Year= this.selectedyear
    model.Month=this.December
    model.inputValuestate=this.inputValuestate
 this._safetyConfigService.addMonthlyHours(model).subscribe((r: any)=>
    {
      if(r){
          this._notify.success('Saved Sucessfully');
          return
        }
    })
  }
}
